import type { Mission } from '../missions.ts'

export const ed: Mission = {
  id: "ed",
  name: "U.S. Department of Education",
  short: "ED",
  call: "Education",
  kind: "department",
  url: "https://www.ed.gov/",
  established: 1980,
  palette: {
    primary: "#002f3d",
    secondary: "#009d56",
    accent: "#ffd90f",
  },
  colorSource: {
    kind: "site",
    url: "https://www.ed.gov/",
  },
  motif: "oak",
  mission: {
    text: "ED's mission is to promote student achievement and preparation for global competitiveness by fostering educational excellence and ensuring equal access.",
    url: "https://www.ed.gov/about/ed-overview/mission-of-the-us-department-of-education",
  },
  fact: {
    text: "Congress established the Department of Education on May 4, 1980, under the Department of Education Organization Act of 1979.",
    url: "https://www.ed.gov/about/ed-overview/mission-of-the-us-department-of-education",
  },
  seal: {
    file: "public/seals/ed.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Education.svg",
  },
  identifier: {
    about: "https://www.ed.gov/about-us",
    accessibility: "https://www.ed.gov/about/ed-overview/required-notices/website-policies/accessibility-statement",
    foia: "https://www.ed.gov/about/ed-overview/required-notices/freedom-of-information-act-foia",
    noFear: "https://www.ed.gov/about/ed-overview/required-notices/policies-and-reports",
    oig: "https://oig.ed.gov/",
    performance: "https://www.ed.gov/about/ed-overview/ed-strategic-plans-and-annual-reports",
    privacy: "https://www.ed.gov/about/ed-overview/required-notices/privacy/privacy-policy-us-department-of-education",
  },
  media: {
    photos: [
      {
        file: "/media/ed-central-high.jpg",
        small: "/media/ed-central-high-sm.jpg",
        alt: "The brick and limestone facade of Little Rock Central High School behind a lawn and a flowering tree under a clear blue sky.",
        title: "Little Rock Central High School National Historic Site, Arkansas",
        creator: "National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Central_High_School_National_Historic_Site_CHSC_20060713180653.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/ed-tribal-college.jpg",
        small: "/media/ed-tribal-college-sm.jpg",
        alt: "A timber-framed academic building with a red gabled roof and round windows, with mountains in the distance.",
        title: "Math, Science, Social Work, and Psychology Building, Salish Kootenai College, Montana, 2014",
        creator: "U.S. Department of Education",
        source: "https://commons.wikimedia.org/wiki/File:Math,_Science,_Social_Work,_and_Psychology_Building_on_the_Salish_Kootenai_College_Campus_(14354586626).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
